import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import SelfPayDependencyDialogComponent from "./SelfPayDependencyDialog";
import {resetSelfPayDependencyDialog,getSelfPayDependencies} from "../../../store/actions/clients";

export const SelfPayDependencyDialog = connect(
    (state: any) => ({
        open: state.clients.selfPayDependencyDialog?.open ?? false,
        contractId: state.clients.selfPayDependencyDialog?.contractId,
        dependencies: state.clients.selfPayDependencies ?? [],
        pending: state.clients.getSelfPayDependencies.pending
    }),
    (dispatch) => ({
        actions: bindActionCreators(
            {
                onClose: resetSelfPayDependencyDialog,
                getSelfPayDependencies
            },
            dispatch
        )
    })
)(SelfPayDependencyDialogComponent);